













































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { IInfoSchemaItem, IInfoProperty } from "../map/types";
import { isMobile } from "@/common/utils";
import { base64toBlob } from "./Exif";

import { APP_URL } from "@/common/http";
import { L } from "@/common/filters";

@Component({
  name: 'v-property',
  watch: {
    items(value) {
      if (!!value && (this.showMapInfoTab > (value.length-1))) {
        this.showMapInfoTab = 0; //IMPORTANT to reset visible tab
      }
    }
  }
})
export default class extends Vue {
  @Prop({
    default: () => {
      return [];
    }
  }) items: IInfoSchemaItem[];
  @Prop({
    default: 0
  }) ident : number;

  appUrl = APP_URL;
  showMapInfoTab: number = 0;
  
  mounted() {
  }

  beforeDestroy() {
  }

  get isMobile() : boolean {
    return isMobile();
  }

  get User() {
    return this.$store.getters.User;
  }

  get language() : string {
    return this.User.Language;
  }

  isMultiLine(prop:any) : boolean {
    return prop.ctrlType=='textarea' || 
          ((!prop.dataType || prop.dataType=='text') && !prop.canEdit);
  }
  
  onMapInfoSelectChange(prop, properties) {
    // IMPORTANT use this as an intermedia to call prop.onOptionChange
    // don't call prop.onOptionChange directly, otherwise it alerts that 
    // onOptionChange is not defined
    if (prop.onOptionChange) {
      prop.onOptionChange(properties);
    }
    if (!!prop.name.match(/type_fk_g|genus_fk_g/)) {
      let crop:any = {};
      properties.forEach((property)=> {
        if (!!property.name.match(/type_fk_g|genus_fk_g|crop_fk_g/)) {
          crop[property.name] = property.value;
        }
      });
      this.items.forEach((item) => {
        item.properties.forEach((property) => {
          if (property.setProperty) {
            property.setProperty(crop,property.value);
          }
        });
      });
    }
  }

  onMapInfoDateChange(prop, properties) {
    if (prop.onChange) {
      prop.onChange(properties);
    }
  }

  async onMapInfoAutoSearch(prop, properties) {
    try {
      if (prop.autoSearch) {
        await prop.autoSearch(this.User, properties);
      }
    } catch (error) {
      this.alertError(error.message || 'Error from onMapInfoAutoSearch()');
    }
  }
  
  getMapInfoPhotoUrl(prop) : string {
    //let test = 'https://picsum.photos/500/300?image=15';
    let noImage = this.appUrl +'/static/images/ppix_enabled.png?APIID=th.co.softoo.rest';
    if (!prop.value) {
      return noImage;
    } else if (prop.value=='loading') {
      return undefined;
    } else if ((prop.value+'').match(/^data:image\/[a-z]+;base64,/i)) {
      let blob = base64toBlob(prop.value);
      let url = URL ? URL.createObjectURL(blob) : window['webkitURL'].createObjectURL(blob);
      return url;
    } else if ((prop.value+'').match(/^blob:/i)) {
      return prop.value;
    } else if (prop.value instanceof Blob) {
      // no good, the UI will flick
      return (URL) ? URL.createObjectURL(prop.value) : 
                    window['webkitURL'].createObjectURL(prop.value);
    } else if (prop.photoUrl) {
      return this.appUrl + prop.photoUrl() + '?APIID=th.co.softoo.rest&width=128&height=128';
    }
    return noImage;
  }

  selectMapInfoFarmerPhotoFile(prop:IInfoProperty) {
    if (this.$refs.MapInfoFarmerPhoto) {
      this.MapInfoPhotoProperty = prop;
      (<HTMLElement>this.$refs.MapInfoFarmerPhoto).click();
    } else {
      this.MapInfoPhotoProperty = null;
    }
  };

  resetMapInfoFarmerPhotoInput = function() {
    try {
      if (this.$refs.MapInfoFarmerPhoto) {
        this.$refs.MapInfoFarmerPhoto.value = '';
        this.$refs.MapInfoFarmerPhoto.type = '';
        this.$refs.MapInfoFarmerPhoto.type = 'file';
      }
    } catch(e) {}
  }

  onMapInfoFarmerPhotoChange(event) {
    if (this.MapInfoPhotoProperty) {
      this.MapInfoPhotoProperty.value ='loading';
      let file = event.target.files[0];
      if (file) { //file is not defined when cancel
        //does not make it show faster
        //this.MapInfoPhotoProperty.value = URL ? URL.createObjectURL(file) : 
        //                                  window['webkitURL'].createObjectURL(file);
        // follwoing is to resize the image
        let fileReader = new FileReader();
        fileReader.onload = this.setMapInfoFarmerPhoto;
        fileReader.readAsArrayBuffer(file);
      }
    }
  }

  Jimp;
  MapInfoPhotoProperty:IInfoProperty;
  async setMapInfoFarmerPhoto(event) {
    try {
      if (!this.Jimp) {
        this.Jimp = require('jimp');
      }
      let arrayBuffer = event.target['result'];
      let buffer = Buffer.from(arrayBuffer);
      let photo = await this.Jimp.read(buffer);
      let w = photo.bitmap.width;
      let h = photo.bitmap.height;
      if (w>h) {
        photo = photo.crop((w-h)/2,0,h,h);
      } else if (w<h) {
        photo = photo.crop(0,(h-w)/2,w,w);
      }
      photo.resize(128,128);
      buffer = await photo.getBufferAsync(this.Jimp.MIME_PNG);
      // buffer to Uint8Array
      //let a = new Uint8Array(buffer.length);
      //for (let i=0; i<buffer.length; i++) a[i] = buffer[i];
      let blob = new Blob([new Uint8Array(buffer)],{type:'image/png'});
      //let base64 = await photo.getBase64Async(this.Jimp.MIME_PNG);
      //let blob = base64toBlob(base64, this.Jimp.MIME_PNG);
      //this.MapInfoPhotoProperty.value = blob; //no good, the UI will flick
      this.MapInfoPhotoProperty.value = (URL) ? URL.createObjectURL(blob) : 
                                        window['webkitURL'].createObjectURL(blob);
    } catch (error) {
      this.MapInfoPhotoProperty.value = this.MapInfoPhotoProperty.originalValue;
      this.alertError(error.message || 'Error from setMapInfoFarmerPhoto()');
    }
  }

  alertError(message) {
    this.$emit('error', message);
  }

}
